import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspacesApi as n } from "@maat/api-main";
//#region src/workspaces/useWorkspaceMembersQuery.ts
var r = (r, i) => t({
	queryKey: [...e.members(), r?.search ?? ""],
	queryFn: () => n.getMembers(r),
	enabled: i?.enabled ?? !0
});
//#endregion
export { r as useWorkspaceMembersQuery };
